export const PIC_INPUT = 600; //奇妙元照片限制200字
export const MOYIN_VIP_INPUT = 5000;//魔音会员5000字
